import { defineMessages } from 'react-intl';

import { MiniCoachmarkTypes } from './MiniCoachmark';

export const ModalCoachmarkSubtype = 'ModalCoachMark';
export const SimStreamModalSubtype = 'SIM_STREAM_SUBTYPE';
export const PremiumWelcomeModalSubtype = 'PREMIUM_WELCOME_SUBTYPE';
export const AccountMessageBlueBarSubtype = 'ACCOUNT_MESSAGE_SUBTYPE';
export const SubscriptionMessageBlueBarSubtype = 'SUBSCRIPTION_MESSAGE_SUBTYPE';
export const BrowserBarSubtype = 'BROWSER_BAR';
export const AdBlockerMessageBlueBarSubtype = 'AD_BLOCKER_MESSAGE_BAR';

export const OFFLINE_NOTIFICATION_BG_COLOR = 'rgba(51,51,51,1)';

export const overlayMessages = defineMessages({
  listenInPandora: {
    id: 't.listenInPandora',
    defaultMessage: 'Listen in Pandora.',
  },
  getTheApp: {
    id: 't.getTheApp',
    defaultMessage: 'Get the app',
  },
  openPandora: {
    id: 't.openPandora',
    defaultMessage: 'Open Pandora',
  },
  close: {
    id: 't.close',
    defaultMessage: 'Close',
  },
} as const);

export const OVERLAY_DIMENSIONS = Object.freeze({
  DEFAULT_WIDTH: 555,
  DEFAULT_HEIGHT: 80,
  ARROW_WIDTH: 10,
  ARROW_HEIGHT: 10,
} as const);

export const OVERLAY_CONFIG = Object.freeze({
  TYPE: 'TYPE', // one of OVERLAY_TYPES e.g. modal
  SUBTYPE: 'SUBTYPE', // string identifier to determine which particular component to show
  ID: 'ID', // reference that will let you update/close the overlay
  PROPS: 'PROPS', // props passed into the component
} as const);

export const OVERLAY_TYPES = Object.freeze({
  coachmark: 'coachmark',
  modal: 'modal',
  blueBar: 'blueBar',
  anchored: 'anchored',
  hamburgerMenu: 'hamburgerMenu',
} as const);

export const OVERLAY_SUBTYPES = Object.freeze({
  OFFLINE: 'offline',
  MODALSHARE: 'ModalShare',
  MODAL_STANDARD: 'ModalStandard',
  MODAL_CUSTOM: 'ModalCustom',
  MODAL_COACHMARK_DIALOG: 'ModalCoachmarkDialog',
} as const);

// this is a list of overlay ids from lowest to highest priority
// first we check this list for ID, then fall back to subtype, then to type
export const OVERLAY_PRIORITIES = [
  'lowestPriorityId',

  OVERLAY_TYPES.anchored, // catch any anchored overlays without IDs or subtypes listed here

  OVERLAY_TYPES.coachmark, // catch any coachmarks without IDs or subtypes in this list

  OVERLAY_TYPES.blueBar, // catch any blueBars without IDs or subtypes in this list
  BrowserBarSubtype, // higher priority than other blueBars

  ModalCoachmarkSubtype, // lower priority than other modals
  MiniCoachmarkTypes.SKIP_LIMIT_REACHED, // higher priority than other modalCoachmarks
  MiniCoachmarkTypes.SKIP_LIMIT_REACHED_FLEX, // higher priority than other modalCoachmarks
  MiniCoachmarkTypes.THUMB_DOWN, // higher priority than other modalCoachmarks
  MiniCoachmarkTypes.BINGE_SKIPPER, // higher priority than other modalCoachmarks
  MiniCoachmarkTypes.FIRST_TIME_FEEDBACK, // higher priority than other modalCoachmarks
  MiniCoachmarkTypes.FIRST_TIME_PODCAST_COLLECTIONS, // higher priority than other modalCoachmarks

  OVERLAY_TYPES.hamburgerMenu,
  OVERLAY_TYPES.modal, // catch any modals without IDs or subtypes in this list
  PremiumWelcomeModalSubtype,
  SimStreamModalSubtype,

  'highestPriorityId',
];

export const OVERLAY_ACTIONS = Object.freeze({
  CHECK_AND_MAYBE_OPEN_OVERLAY: 'CHECK_AND_MAYBE_OPEN_OVERLAY',
  OPEN_OVERLAY: 'OPEN_OVERLAY',
  CLOSE_OVERLAY: 'CLOSE_OVERLAY',
  HIDE_PODCAST_COLLECTIONS_COACHMARK: 'HIDE_PODCAST_COLLECTIONS_COACHMARK',
  COACHMARK_CLICKED: 'COACHMARK_CLICKED',
} as const);

export default OVERLAY_ACTIONS;
